let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iMP7C")).then(() => parcelRequire('2la6R'));